import marked from './marked'

export default new marked.Renderer()



// WEBPACK FOOTER //
// ./src/utils/marked-renderer.js